import { useState } from 'react';

import { PaginationState } from '@tanstack/react-table';

import ReconciliationRunDetailsGate from 'app/components/Reconciliations/ReconciliationRunDetailsGate';
import ReconciliationPagedTable from 'app/components/Reconciliations/ReconciliationPagedTable';

import { defaultPageSize } from 'app/constants/table';

import useFetchSalaryUncheckedIndividuals from 'app/hooks/useFetchSalaryUncheckedIndividuals';

import getSalaryUncheckedIndividualColumns from 'app/utils/table/salaryUncheckedIndividuals';

interface SalaryNotCheckedTabProps {
  reconciliationId: string;
  companyId?: string;
  isRunning: boolean;
}

/** Lists the individuals a salary accrual reconciliation run could not check, and why. */
function SalaryNotCheckedTab({
  reconciliationId,
  companyId = undefined,
  isRunning,
}: SalaryNotCheckedTabProps) {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: defaultPageSize,
  });

  const { data, isLoading, isError } = useFetchSalaryUncheckedIndividuals(
    {
      id: reconciliationId,
      companyId,
      page: pagination.pageIndex,
      size: pagination.pageSize,
    },
    !isRunning
  );

  return (
    <ReconciliationRunDetailsGate
      isRunning={isRunning}
      detailsAvailable
      pendingText="The individuals it could not check"
    >
      <ReconciliationPagedTable
        page={data}
        isLoading={isLoading}
        isError={isError}
        columns={getSalaryUncheckedIndividualColumns(!companyId)}
        pagination={pagination}
        onPaginationChange={setPagination}
        getRowId={(individual) => individual.individualId}
        emptyText="This run checked every individual"
        errorText="Sorry, we failed to fetch the individuals. Please try again."
        testId="salary-reconciliation-not-checked"
      />
    </ReconciliationRunDetailsGate>
  );
}

export default SalaryNotCheckedTab;
